
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar,IonCardContent,IonAccordion,IonAccordionGroup,IonGrid,IonRow,IonCol,IonItem, IonCard   } from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCardContent,IonAccordionGroup,IonGrid,IonRow,IonCol,IonAccordion,IonItem,IonCard

    
  }
});
